import React from 'react'

import Style from './GaugeLabel.module.css'

export const GaugeLabel = ({ icon }) => (
  <div className={Style['label']}>
    <img src={icon} alt="" width="16" height="16" />
  </div>
)
